/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Column_ScoreInputs */

const en_admin_user_detail_column_score = /** @type {(inputs: Admin_User_Detail_Column_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching score`)
};

const de_admin_user_detail_column_score = /** @type {(inputs: Admin_User_Detail_Column_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching-Score`)
};

/**
* | output |
* | --- |
* | "Matching score" |
*
* @param {Admin_User_Detail_Column_ScoreInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_column_score = /** @type {((inputs?: Admin_User_Detail_Column_ScoreInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Column_ScoreInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_column_score(inputs)
	return en_admin_user_detail_column_score(inputs)
});